import formatPeriodLabel from '../../helpers/compareHelpers/formatPeriodLabel'

// AI-CONTEXT: See docs/features/deep-analysis-period.md
// Two portal targets side by side, one per compared period, each labelled
// with its period (same teal/coral swatch as ComparisonFrame). Used by the
// context card (facts / details) and the 'Deelname' section — the panes the
// result card's two copies portal into via slotsForSide.

/**
 * @typedef {{start: string|null, end: string|null}|null} PeriodRange
 */

/**
 * @param {object} props
 * @param {PeriodRange} props.rangeA - Primary period
 * @param {PeriodRange} props.rangeB - Compare period
 * @param {(el: HTMLElement|null) => void} props.setElA - Ref callback for the primary period's pane
 * @param {(el: HTMLElement|null) => void} props.setElB - Ref callback for the compare period's pane
 * @param {string} props.paneClassName - Class of each pane body (keeps the styling of the single-pane version)
 */
const DeepAnalysisComparePanes = ({ rangeA, rangeB, setElA, setElB, paneClassName }) => (
    <div className='deep-analysis-compare-panes'>
        {[['a', rangeA, setElA], ['b', rangeB, setElB]].map(([side, range, setEl]) => {
            const label = formatPeriodLabel(range)
            return (
                <section key={side} className='deep-analysis-compare-pane' aria-label={label}>
                    <div className={`comparison-frame-panel-header comparison-frame-panel-header--${side}`}>
                        <span className='comparison-frame-swatch' />
                        <span className='comparison-frame-panel-label'>{label}</span>
                    </div>
                    <div className={paneClassName} ref={setEl} />
                </section>
            )
        })}
    </div>
)

export default DeepAnalysisComparePanes
